import React from "react";

export const defaultIcons = {
  iconPlus: (
    <div className="rd--button-icon__plus">
      <span className="rd--button-icon__plus--line" />
      <span className="rd--button-icon__plus--line" />
    </div>
  )
};

export const defaultIconNames = ["iconPlus"];
